import { rankingApi } from '@/helpers/api'
import { defineStore } from 'pinia'
import { jobs } from '@/config/rankings/job'
import { legacyWorlds } from '@/config/rankings/world'

// ranking api spec
export interface RankInfo {
  characterImgURL: string
  characterName: string
  rank: number
  level: number
  worldID: number
  worldName: string
  jobID: number
  jobDetail: number
  jobName: string
  exp: number
  gap: number
  starSum: number
  // tierName: string
  tierID: number
  legionLevel: number
  raidPower: number
}

export const useRankingStore = defineStore('Ranking', {
  state: () => ({
    homeRankings: [] as RankInfo[],
  }),
  actions: {
    async fetchHomeRankings() {
      if (this.homeRankings.length > 0) return
      const { ranks } = await this.fetch({ type: 'overall', id: 'weekly', rebootIndex: 0 })
      this.homeRankings = ranks
    },
    async fetch({
      region = 'na',
      type,
      id,
      rebootIndex,
      pageIndex,
      characterName,
    }: {
      region?: string
      type: string
      id?: string | number | undefined
      rebootIndex?: string | number | undefined
      pageIndex?: number | undefined
      characterName?: string | undefined
    }) {
      let url = `/${region}?type=${type}`
      if (id !== undefined) url += `&id=${id}`
      if (rebootIndex !== undefined) url += `&reboot_index=${rebootIndex}`
      if (pageIndex !== undefined) url += `&page_index=${pageIndex}`
      if (characterName) url += `&character_name=${characterName}`

      const { data }: { data: { ranks: RankInfo[]; totalCount: number } } = await rankingApi.get(url)
      data.ranks.forEach((rank) => {
        if (rank.jobID === 3 && rank.jobDetail in [1, 30, 31, 32, 33]) rank.jobName = 'Pathfinder'
        else if (rank.jobID === 4 && rank.jobDetail in [30, 31, 32, 33, 34]) rank.jobName = 'Dual Blade'
        else {
          rank.jobName = jobs.find((x) => x.id === rank.jobID)?.name ?? 'Unknown'
        }
        rank.worldName = legacyWorlds.find((x) => x.id === rank.worldID)?.name ?? 'Unknown'
      })
      return data
    },
  },
})
